import {
  getAboutPage,
  getBasicInfo,
  getCoreFeatures,
  getMenus,
  getOfficialHome,
  getPartners,
  getProducts,
  saveAboutPage,
  saveBasicInfo,
  saveCoreFeatures,
  saveMenus,
  savePartners,
  saveProducts
} from "./content";
import { login, logout, profile } from "./auth";

export const mockRouteMap = {
  "GET /admin/menus": ({ params }) => getMenus(params),
  "PUT /admin/menus": ({ data }) => saveMenus(data),

  "GET /admin/basic-info": ({ params }) => getBasicInfo(params),
  "PUT /admin/basic-info": ({ data }) => saveBasicInfo(data),

  "GET /admin/partners": ({ params }) => getPartners(params),
  "PUT /admin/partners": ({ data }) => savePartners(data),

  "GET /admin/products": ({ params }) => getProducts(params),
  "PUT /admin/products": ({ data }) => saveProducts(data),

  "GET /admin/core-features": ({ params }) => getCoreFeatures(params),
  "PUT /admin/core-features": ({ data }) => saveCoreFeatures(data),

  "GET /admin/about-page": ({ params }) => getAboutPage(params),
  "PUT /admin/about-page": ({ data }) => saveAboutPage(data),

  "POST /auth/login": ({ data }) => login(data),
  "POST /auth/logout": () => logout(),
  "GET /auth/profile": ({ headers }) => profile(headers),

  "GET /official/home": () => getOfficialHome()
};
